import { assembleNameWithEmailFallback, tokens, User, UserBubble } from 'ComponentLibrary'
import { Stack } from '@mui/material'
import { Typography } from 'ComponentLibrary/src/piazza'
import { ComponentProps } from 'react'
import { TaskAssignee } from 'ComponentLibrary/src/common/users'

type UserNameLabelProps = {
    user: Pick<User, 'profile_image_url' | 'profile_thumbnail_image_url'> &
        Pick<TaskAssignee, 'last_name' | 'first_name' | 'email' | 'organization_name'>
    size?: `${number}px`
    variant?: ComponentProps<typeof Typography>['variant']
    customerNameVariant?: ComponentProps<typeof Typography>['variant']
}

export const UserBubbleWithName = ({
    user,
    variant = 'textXS',
    size = tokens.SizingIconS,
    customerNameVariant = 'textXS',
}: UserNameLabelProps) => {
    return (
        <Stack direction="row" alignItems="center" gap={tokens.SizingSpacing075}>
            <UserBubble size={size} profileImageUrl={user.profile_thumbnail_image_url} profileFallbackImageUrl={user.profile_image_url} />
            <Stack direction="column">
                <Typography variant={variant} color={tokens.ColorTextBold}>
                    {assembleNameWithEmailFallback(user)}
                </Typography>
                <Typography variant={customerNameVariant} color={tokens.ColorTextDefault}>
                    {user.organization_name}
                </Typography>
            </Stack>
        </Stack>
    )
}
